import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[layout-host]',
  exportAs: 'LayoutHostDirective'
})
export class LayoutHostDirective {
  // @ViewChildren(AbstractControlContainerComponent) children: QueryList<AbstractControl<any>>;

  constructor(public viewContainerRef: ViewContainerRef) {}
}
